var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_78065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.046875 3.7406H59.9531V7.3406H0.046875V3.7406ZM0.046875 11.1187H59.9531V14.7187H0.046875V11.1187ZM0.046875 18.5062H59.9531V22.1062H0.046875V18.5062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.046875H30V26.2969H0V0.046875Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4531 6.91875L20.0156 10.7344L22.1718 7.54688L21.0093 11.2219L24.3374 9.27188L21.7031 12.0844L25.5468 11.7844L21.9562 13.1719L25.5468 14.5594L21.7031 14.2594L24.3374 17.0719L21.0093 15.1219L22.1624 18.8063L20.0062 15.6094L19.4437 19.425L18.8906 15.6094L16.7343 18.7969L17.8968 15.1219L14.5687 17.0719L17.1937 14.2594L13.3499 14.5594L16.9499 13.1719L13.3593 11.7844L17.2031 12.0844L14.5687 9.27188L17.8968 11.2219L16.7343 7.5375L18.8906 10.7344L19.4531 6.91875ZM16.3312 7.07813C15.3164 6.62829 14.2053 6.439 13.0989 6.52744C11.9924 6.61588 10.9255 6.97925 9.99504 7.58457C9.06459 8.18988 8.30004 9.01798 7.77078 9.9937C7.24152 10.9694 6.96432 12.0619 6.96432 13.1719C6.96432 14.2819 7.24152 15.3743 7.77078 16.3501C8.30004 17.3258 9.06459 18.1539 9.99504 18.7592C10.9255 19.3645 11.9924 19.7279 13.0989 19.8163C14.2053 19.9048 15.3164 19.7155 16.3312 19.2656C15.2104 20.0698 13.8897 20.5492 12.5141 20.6513C11.1385 20.7534 9.76136 20.4741 8.53419 19.8443C7.30702 19.2144 6.27733 18.2583 5.55836 17.0811C4.83939 15.9039 4.45898 14.5513 4.45898 13.1719C4.45898 11.7925 4.83939 10.4398 5.55836 9.26266C6.27733 8.08547 7.30702 7.12937 8.53419 6.49949C9.76136 5.86961 11.1385 5.59036 12.5141 5.69245C13.8897 5.79453 15.2104 6.274 16.3312 7.07813Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.046875 25.8938H59.9531V29.4938H0.046875V25.8938ZM0.046875 33.225H59.9531V36.825H0.046875V33.225ZM0 41.4H59.9062V45H0V41.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_78065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/ms.a7e6620414fc7afead7e089fb47c09de.svg";
export { ForwardRef as ReactComponent };